import React, { Component } from "react";
import IOSshare from "../images/ios-share.svg";
class IOSBanner extends React.Component {
    render() {
        return (
            <div className="install-banner__ios">
                <p>
                    Install this app on your home screen: Tap{" "}
                    <img
                        className="install-banner__ios__icon"
                        src={IOSshare}
                        alt="IOS share icon"
                    />{" "}
                    then Add to Home Screen.
                </p>
            </div>
        );
    }
}

class FireFoxBanner extends React.Component {
    render() {
        return (
            <div className="install-banner__ios">
                <p>
                    Install this app on your home screen: Tap <svg className="install-banner__ff__icon">
                        <use xlinkHref="#three-dots" />
                    </svg> then click 'Install' or 'Add to Home Screen'.
                </p>
            </div>
        );
    }
}

class AndroidBanner extends React.Component {
    render() {
        return (
            <div>
                <button
                    className="btn install-banner__btn"
                    onClick={this.props.onInstallClick}
                    tabIndex="0"
                    aria-label="Install the app"
                >
                    Install App
                </button>
            </div>
        );
    }
}
class InstallBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isInstalled: true,
            removeBanner: document.cookie.includes("removeBanner=true"),
            ios: false,
            firefox: false,
            chrome: false,
        };
        this.handleInstallClick = this.handleInstallClick.bind(this);
        this.handleInstallPrompt = this.handleInstallPrompt.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);
    }

    componentDidMount() {
        // Chrome
        const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        if (isChrome) {
            this.setState({ isInstalled: false, chrome: true });
            window.addEventListener("beforeinstallprompt", this.handleInstallPrompt);
        }

        // IOS
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (isIOS) {
          this.setState({ isInstalled: false, ios: true });
        } 

        // Firefox
        const isFirefox = /Firefox/.test(navigator.userAgent) && /Mobile|Tablet/.test(navigator.userAgent);
        if (isFirefox) {
            this.setState({ isInstalled: false, firefox: true });
        }
        
        if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) {
          this.setState({ removeBanner: true });
        }
      }

    componentWillUnmount() {
        window.removeEventListener(
            "beforeinstallprompt",
            this.handleInstallPrompt
        );
    }

    handleInstallPrompt(event) {
        if (event) {
            event.preventDefault();
            this.installPrompt = event;
            this.setState({ isInstalled: false });
        }
    }

    handleInstallClick() {
        if (this.installPrompt) {
            this.installPrompt.prompt();
            this.installPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === "accepted") {
                    console.log("User accepted the install prompt");
                    this.setState({ isInstalled: true, removeBanner: true });
                } else {
                    console.log("User dismissed the install prompt");
                    this.setState({ isInstalled: false });
                }
                this.installPrompt = null;
            });
        }
    }

    handleCloseClick() {
        setTimeout(() => {
            this.setState({ removeBanner: true });
        }, 1000);
        const banner = document.querySelector(".install-banner");
        banner.classList.add("close-animation");

        // Set a cookie that clear in 3 days
        document.cookie =
            "removeBanner=true; expires=" +
            new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toUTCString();
    }

    render() {
        const { isInstalled, removeBanner, ios, firefox, chrome } = this.state;
        if (removeBanner) {
            return null;
        }

        return (
            <div>
                {!isInstalled && (
                    <div className="install-banner">
                        {ios && (
                            <IOSBanner />
                        )} 
                        
                        {chrome && (
                            <AndroidBanner
                                onInstallClick={this.handleInstallClick}
                            />
                        )}

                        {firefox && (
                            <FireFoxBanner
                                onInstallClick={this.handleInstallClick}
                            />
                        )}

                        <div
                            className="install-banner__close"
                            onClick={this.handleCloseClick}
                            tabIndex="0"
                            aria-label="Close the install banner"
                        >
                            <span className="install-banner__close-icon">
                                &times;
                            </span>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default InstallBanner;



// WEBPACK FOOTER //
// ./src/components/InstallBanner.js